<div
  class="destinations-countries-container"
  [class]="themeService.getTheme()"
  *ngIf="(alone && countries.length > 0) || (!alone && continents.length > 0)"
>
  <div class="destinations-countries-header">
    <div class="destinations-countries-header-title">
      <app-texts
        [texts]="[
          {text: ['Страны', 'Countries']}
        ]"
      />
    </div>
    <div class="header-continents-container-wrapper">
      <div class="scroll-shadow left-shadow" [class.active]="canScrollLeft"></div>
      <div class="scroll-shadow right-shadow" [class.active]="canScrollRight"></div>
      <div class="header-continents-container"
           #continentsContainer
           (mousedown)="onMouseDown($event)"
           (touchstart)="onTouchStart($event)"
           (wheel)="onWheel($event)">
        <div *ngFor="let continent of getContinents(); index as i">
          <div
            class="continent-el"
            [class]="{ 'continent-el-active': activeContinent == i }"
            (click)="onContinentClick($event, i, continent.id ?? 0, continent.titleEn)"
            #continentEl
          >
            <app-texts
              [texts]="[
              {text: [continent.titleRu, continent.titleEn]}
            ]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="destinations-countries-workspace">
    <app-texts
      *ngIf="!isLoading() && countries.length === 0 && !alone"
      style="padding: 1rem; font-size: 24px"
      [texts]="[
        {text: ['Направления не найдены', 'Destinations not found']}
      ]"
    />
    <div *ngIf="countries.length > 0" style="min-height: 100dvh">
      <div *ngFor="let country of countries">
        <app-country-info-el
          [location]="country"
          [border]="true"
        />
      </div>
      <div #scrollTrigger *ngIf="!fullData" class="scroll-trigger"></div>
    </div>
    <app-loading *ngIf="isLoading()" [height]="150"/>
  </div>
</div>
